module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_7016.1772d4df.png";